import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {persistStore, persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import tokenReducer from "./reducers/tokenReducer";
import languageReducer from './reducers/languageReducer';
import api from "../store/middleware/api";
import userReducer from './reducers/userReducer';
import websettingsReducer from './reducers/websettingsReducer';

const persistConfig = {
    key: 'root',
    storage,
}

const rootReducer = combineReducers({
    token: tokenReducer,
    languages: languageReducer,
    user: userReducer,
    websettings: websettingsReducer
});

export const store = configureStore({
    reducer: persistReducer(persistConfig, rootReducer),
    middleware: [
        api
    ]
});

export const persistor = persistStore(store);